// extracted by mini-css-extract-plugin
export var cell = "_4v-4";
export var headerCell = "_4v-2";
export var rowHeader = "_4v-3";
export var table = "_4v-1";
export var tableContainer = "_4v-0";